module.exports = __webpack_public_path__ + "img/legume-shell-beans-350x184.997b60af.jpg";